<template>
    <div>
        <BoxPaciente
            ref="BoxPaciente"
            :data="data"
        />

        <Buscar
            :data="data"
        />

        <rkm-row
            v-if="data.model.agendamentos && data.model.agendamentos.length > 0"
            class="mt-2 mb-2"
        >
            <rkm-col>
                <template>
                    <rkm-button
                        color="info"
                        class="mb-2"
                        @click="imprimirHistorico()"
                    >
                        Imprimir histórico
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-table
            :fields="fields.tables.agendamento"
            :items="data.model.agendamentosNotSave || data.model.agendamentos"
            ref="Table"
            :tbody-tr-attr="handleRowAttr"
            sort-by="data"
            hide-filters
        >
            <template v-slot:cell(data)="row">
                {{ row.item.data.split("-").reverse().join("/") }}
            </template>

            <template v-slot:cell(incluido)="row">
                {{ examesIncluido(row.item.incluido) }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    :id="uniqueId('show-btn')"
                    @click="$refs.Modal.open(item)"
                    title="Detalhamento"
                    small
                    color="primary"
                >
                    <rkm-icon icon="search" />
                </rkm-button>

                <rkm-button
                    @click="handlePrint(item)"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click="handleEtiquetaPrint(item)"
                    color="warning"
                    class="colorButton"
                    small
                    title="Imprimir etiqueta"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="tags" />
                </rkm-button>

                <rkm-button
                    color="primary"
                    title="Editar"
                    small
                    @click.stop="$emit('handleAlter', item, index)"
                    :disabled="item.pedido || item.retroativo || item.fromRegulacao"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(item)"
                    :disabled="item.pedido || item.retroativo"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <rkm-row class="mt-2">
            <rkm-col>
                <p class="m-0">
                 Linhas em <span class="warning">amarelo</span> representam exames com urgência.
                </p>
                <p class="m-0">
                    Linhas em <span class="primary">azul</span> representam os agendamentos retroativos.
                </p>
            </rkm-col>
        </rkm-row>

        <Modal
            ref="Modal"
            :data="data"
        />
    </div>
</template>

<script>

// Components.
import Buscar from '@/components/exame-imagem/agendamento/tabs/agendados/Form'
import Modal from '@/components/exame-imagem/agendamento/tabs/agendados/components/Modal'
import BoxPaciente from '@/components/exame-imagem/agendamento/paciente/Index'

// Moment.
import moment from 'moment'

// Filters.
import formats from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

//Enums
import status from '@/enums/exame-imagem/fechamento/status'

// Mixins.
import { repository, error, object, data, stringCase, printExameImagem } from '@/mixins'

export default {
    components:{ Buscar, Modal, BoxPaciente },
    computed:{
        fields() {

            return {
                tables: {
                    agendamento: [
                        { key: 'data', label: 'Data', class: 'col-max', sortable: true },
                        { key: 'agendamentoNumero', label: 'Agendamento', class: 'col-max', sortable: true },
                        { key: 'grupoExameNome', label: 'Grupo de exame', class: 'col-max', sortable: true },
                        { key: 'incluido', label: 'Exames', class: 'col-max', sortable: true },
                        { key: 'unidadeNome', label: 'Unidade executante', class: 'col-max', sortable: true },
                        { key: 'profissionalNome', label: 'Profissional executante', class: 'col-max', sortable: true },
                        { key: 'horaExame', label: 'Horário', class: 'col-min', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center'}
                    ]
                }
            }
        },
    },
    created() {

        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        }
    },
    data:() => ({
        agendamento: {
            data: null,
            grupoExameId: null,
            grupoExameNome: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            agendamentoId: '',
            unidadeId: null,
            unidadeNome: '',
            unidadeDisabled: false,
            usuarioId: '',
            urgente: false,
            periodo: {
                start: null,
                end: null,
            },
            prestadorId: null,
            prestadorNome: '',
            medicoNome: '',
            medicoId: null,
        },
        isReadOnly: false,
        enums: {
            status
        },
    }),
    filters: {
        ...formats,
    },
    mixins: [ repository, error, object, data, stringCase, printExameImagem ],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        examesIncluido(item){

            let nomeExames = ''

            if (item) {

                item.forEach(exameNomeIncluido => {

                    if(!nomeExames){

                        nomeExames = exameNomeIncluido.nome
                    } else {

                        nomeExames = nomeExames + ', ' + exameNomeIncluido.nome
                    }
                })
            }

            return nomeExames
        },
        validate() {
            return this.$refs.Form.validate()
        },
        handleDestroy(item) {

            this.data.model.agendamentos.filter(obj => obj.agendamentoId == item.agendamentoId)
                .forEach(exameIncluido => {

                    if(exameIncluido.incluido.find(m => m.statusId == this.enums.status.REALIZADO || m.statusId == this.enums.status.FALTOU)){

                        this.showValidationNotification(`Não é possível realizar a exclusão desse agendamento, ` + `
                             pois há um ou mais exames realizado ou paciente faltante.`)

                    } else {

                        const destroy = () => new Promise(resolve => {

                        const objId = this.data.model.agendamentos.findIndex((obj => obj.agendamentoId == item.agendamentoId));

                            resolve(this.data.model.agendamentos.splice(objId, 1))
                        })

                        .then(() => {

                            this.$emit('loadDays', this.data.model.agendamentos)
                        })

                        this.showDeleteConfirmation(`Deseja realmente excluir essa agendamento?`, destroy)
                    }
                })
        },
        getCalendar() {

            this.$emit('loadDays', this.data.model.agendamentos)
        },
        handleEtiquetaPrint(item) {

            let etiqueta = {
                pacienteNome: item.pacienteNome,
                agendamentoNumero: item.agendamentoNumero,
                medicoNome: item.medicoNome,
                data: moment(item.date).format('DD/MM/YYYY'),
                unidadeNome: item.unidadeNome,
                examesIncluido: item.incluido,
                dataNascimento: this.data.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
            }

            this.print().etiqueta(etiqueta)
        },
        handlePrint(item) {
            let agendamento = {
                pacienteNome: item.pacienteNome,
                prontuario: this.data.form.paciente.prontuario,
                nomeResponsavel: item.nomeResponsavel,
                dataNascimento: this.data.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
                agendamentoNumero: item.agendamentoNumero,
                medicoNome: item.medicoNome,
                profissionalNome: item.profissionalNome,
                observacao: item.observacao,
                grupoExameNome: item.grupoExameNome,
                data: moment(item.data).format('DD/MM/YYYY'),
                examesIncluido: item.incluido,
                horaExame: item.horaExame,
                unidadeSolicitante: item.unidadeSolicitanteNome,
                logotipo: this.data.form.cliente.logotipo,
                nomePrefeitura: this.data.form.cliente.nome,
                ramoAtividade: this.data.form.cliente.sistema.ramoAtividade.nome,
                mensagemProtocolo: this.data.form.mensagemProtocolo,
                sistemaNome: this.data.form.cliente.sistema.nome,
                sistemaVersao: this.data.form.cliente.sistema.versao,
                usuario: this.data.form.usuario,
                urgente: item.urgente,
                unidadeExecutante: item.infraestruturaNome,
                enderecoExecutante: item.infraestruturaEndereco,
                numeroEnderecoExecutante: item.infraestruturaNumero,
                bairroExecutante: item.infraestruturaBairro,
                telefoneExecutante: item.infraestruturaTelefone,
            }

            this.print().agendamento(agendamento)
        },
        handleRowAttr(item, type) {
            if (type === 'row') {

                if (item.retroativo) {
                    return {
                        style: `
                            border-left: 10px solid #007bff;
                            background-color: #007bff17;
                        `
                    }
                } else if (item.urgente) {
                    return {
                        style: `
                            border-left: 10px solid #ffc107;
                            background-color: #ffc10715;
                        `
                    }
                }
            }
        },
        imprimirHistorico(){

            this.setLoading()

            this.repositories.impressao.historicoExame(this.data.form.paciente.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
.warning {
    color: var(--warning);
}
.primary {
    color: var(--primary);
}
.colorButton {
    color: #fff;
}
</style>